import { useTranslation } from 'react-i18next';
import Tooltip from 'components/Tooltip';

const FooterSection = ({
  title,
  connect,
  termsUrl,
  privacyUrl,
  social,
  e2e,
}: {
  title: string;
  connect: string;
  termsUrl: string;
  privacyUrl: string;
  social: { icon: string; link: string; label: string }[];
  e2e: string;
}) => {
  const { t } = useTranslation();

  return (
    <div data-e2e={`${e2e}-footer-section_container`} className='flex flex-col gap-2'>
      <p className='font-[DKLiquidEmbrace] font-normal text-sm leading-4 tracking-[1.26px] text-grey800 max-lg:text-center'>
        {title}
      </p>

      <div
        data-e2e={`${e2e}-legal-links`}
        className='flex text-sm text-gray-600 gap-4 max-lg:gap-1 max-lg:flex-col max-lg:items-center'
      >
        <a
          href={termsUrl}
          target='_blank'
          className='hover:underline font-[MuseoSansCyrl] font-normal text-sm text-grey500'
        >
          {t('footer.termsAndConditions')}
        </a>

        <a
          href={privacyUrl}
          target='_blank'
          className='hover:underline font-[MuseoSansCyrl] font-normal text-sm text-grey500'
        >
          {t('footer.privacyPolicy')}
        </a>
      </div>

      <div>
        <p className='font-[MuseoSansCyrl] font-normal text-sm text-grey800'>{connect}</p>

        <div data-e2e={`${e2e}-social-links`} className='flex gap-4 mt-2'>
          {social.map((media, index) => (
            <Tooltip show position='top' text={media.label} key={index}>
              <div className='w-6 h-6 rounded-full bg-secondary flex items-center justify-center'>
                <a href={media.link} target='_blank' rel='noreferrer'>
                  <img src={media.icon} alt={media.label} />
                </a>
              </div>
            </Tooltip>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
